import { render, staticRenderFns } from "./Imbox.vue?vue&type=template&id=06bf8877&"
import script from "./Imbox.vue?vue&type=script&lang=js&"
export * from "./Imbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports